/**
 * SADA Careers · Applications admin API.
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/careers`;

const authHeader = () => {
  const token = localStorage.getItem('dermascan_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const applicationsApi = {
  async list(status) {
    const params = {};
    if (status) params.status = status;
    const { data } = await axios.get(`${BASE}/admin/applications`, {
      params,
      headers: authHeader(),
    });
    return data;
  },
  async stats() {
    const { data } = await axios.get(`${BASE}/admin/applications/stats`, {
      headers: authHeader(),
    });
    return data;
  },
  async patch(appId, payload) {
    const { data } = await axios.patch(`${BASE}/admin/applications/${appId}`, payload, {
      headers: authHeader(),
    });
    return data;
  },
  async remove(appId) {
    const { data } = await axios.delete(`${BASE}/admin/applications/${appId}`, {
      headers: authHeader(),
    });
    return data;
  },
  fileUrl(appId, kind) {
    // Note: cet URL requiert un token — utilisé côté fetch-blob
    return `${BASE}/admin/applications/${appId}/file/${kind}`;
  },
  async downloadFile(appId, kind) {
    const { data, headers } = await axios.get(`${BASE}/admin/applications/${appId}/file/${kind}`, {
      headers: authHeader(),
      responseType: 'blob',
    });
    return { blob: data, contentType: headers['content-type'] };
  },
};

export const STATUS_LABELS = {
  nouveau: 'Nouveau',
  a_revoir: 'À revoir',
  retenu: 'Retenu',
  refuse: 'Refusé',
};

export const STATUS_COLORS = {
  nouveau: 'bg-blue-100 text-blue-800',
  a_revoir: 'bg-amber-100 text-amber-800',
  retenu: 'bg-emerald-100 text-emerald-800',
  refuse: 'bg-slate-200 text-slate-700',
};

export const POST_LABELS = {
  auxiliaire: 'Auxiliaire',
  pharmacien: 'Pharmacien(ne)',
  stagiaire: 'Stagiaire',
  administratif: 'Administratif',
  livreur: 'Livreur',
  autre: 'Autre',
};
